import api from './axios';
import {MeResponse} from "@/api/types.ts";

interface ExchangeRequest {
  idToken: string;
  store?: string | null;
  returnUrl?: string | null;
  state?: string | null;
}
interface ExchangeResponse {}

export async function exchangeMemberSession(
    payload: ExchangeRequest
): Promise<ExchangeResponse> {
  try {
    const response = await api.post<ExchangeResponse>(
        "/api/v1/member/auth/exchange",
        payload
    );

    return response.data;
  } catch (error) {
    console.error("Failed to exchange member session:", error);
    throw error;
  }
}

export async function fetchMe(): Promise<MeResponse> {
  const res = await api.get<MeResponse>("/api/members/whoiam");
  return res.data;
}